import Row from './src/row2.mjs';
export { RowAlign, RowJustify, rowProps } from './src/row.mjs';
export { rowContextKey } from './src/constants.mjs';
import { withInstall } from '../../utils/vue/install.mjs';

const ElRow = withInstall(Row);

export { ElRow, ElRow as default };
//# sourceMappingURL=index.mjs.map
